export const ALERT_BEGIN = 'ALERT_BEGIN';
export const ALERT_SHOW = 'ALERT_SHOW';
export const ALERT_HIDE = 'ALERT_HIDE';